import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from './http'
import '@/assets/scss/main.scss';
import store from './store';
import VOtpInput from "vue3-otp-input";
import i18n from "./locales/i18n"

// Import plugins
import VueAxios from 'vue-axios'

const app = createApp(App)

app.use(VueAxios, axios)
app.component('v-otp-input', VOtpInput)
app.use(router)
app.use(store)
app.use(i18n);


app.mount('#app')